function enumToSelectOptions(codes, labels, from, to) {
  let options = [];
  for (let i = 0; i < codes.length; i++) {
    let code = codes[i];
    let label = labels[i];
    if (from && code < from) continue;
    if (to && code >= to) continue;
    options.push({ value: code, text: label });
  }
  return options;
}

function enumCodeToLabel(codes, labels, code) {
  for (let i = 0; i < codes.length; i++) {
    if (codes[i] == code) return labels[i];
  }
  return "";
}

export class Status {
  static SUSPENDED = 1;
  static ENTITLED = 2;

  static Codes = [Status.SUSPENDED, Status.ENTITLED];
  static Labels = ["Suspended", "Entitled"];

  static toSelectOptions(from, to) {
    return enumToSelectOptions(Status.Codes, Status.Labels, from, to);
  }

  static codeToLabel(code) {
    return enumCodeToLabel(Status.Codes, Status.Labels, code);
  }
}

export class Role {
  static ROOT = 1 << 0;
  static ADMIN = 1 << 1;
  static STUDENT = 1 << 2;
  static TEACHER = 1 << 3;
  static MANAGER = 1 << 4;
  static MANAGER_CC = 1 << 5;

  static Codes = [
    Role.ROOT,
    Role.ADMIN,
    Role.STUDENT,
    Role.TEACHER,
    Role.MANAGER,
    Role.MANAGER_CC,
  ];

  static Labels = [
    "Root",
    "Admin",
    "Student",
    "Teacher",
    "Manager",
    "Manager CC",
  ];

  static codeToLabels(code) {
    if (code == null || code === 0) {
      return ["None"];
    }

    return Role.Codes.filter((role) => (code & role) === role).map((role) =>
      Role.codeToLabel(role)
    );
  }

  static codeToLabel(code) {
    const highestRole = Math.max(
      ...Role.Codes.filter((role) => (code & role) === role)
    );

    const index = Role.Codes.indexOf(highestRole);
    return index !== -1 ? Role.Labels[index] : "Unknown";
  }

  static labelToCode(label) {
    const index = Role.Labels.indexOf(label);
    return index !== -1 ? Role.Codes[index] : 0;
  }

  static hasRole(code, role) {
    return (code & role) === role;
  }

  static hasAnyRole(code, roles) {
    return (code & roles) !== 0;
  }

  static getHighestRole(code) {
    if (code == null || code === 0) {
      return Role.ROOT;
    }
    const highestRole = Math.max(
      ...Role.Codes.filter((role) => (code & role) === role)
    );
    return highestRole;
  }
}

export class Level {
  static BASIC = 1;
  static ADVANCED = 2;

  static Codes = [Level.BASIC, Level.ADVANCED];
  static Labels = ["Basic", "Advanced"];

  static toSelectOptions(from, to) {
    return enumToSelectOptions(Level.Codes, Level.Labels, from, to);
  }

  static codeToLabel(code) {
    return enumCodeToLabel(Level.Codes, Level.Labels, code);
  }
}
